module.exports = __webpack_public_path__ + "img/barn_pine_696d_detail_rsh.8c915314.jpg";